module.exports = __webpack_public_path__ + "media/icons/standard@2x-75ff6e36.png";